import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField
} from "@mui/material";
import { Typography } from "@mui/material/";
import moment, { Moment } from "moment";
import React, { useState } from "react";

interface Props {
  visible: boolean;
  setVisibility: (visible: boolean) => void;
  onSendApprovement: any;
  onCancel?: () => void;
  userTimeShift: number;
  selectedTime?: string | Moment | null | undefined;
  currentTime?: string | undefined;
}

const ApprovementModal: React.FC<Props> = (props) => {
  const {
    visible,
    setVisibility,
    onSendApprovement,
    onCancel,
    selectedTime,
    currentTime,
    userTimeShift = 15
  } = props;

  const _onSendApprovement = () => {
    console.log("in approvazione");
    onSendApprovement();
  };

  const handleClose = () => {
    setVisibility(false);
    onCancel?.();
  };

  return (
    <Dialog title="Modifica orario" open={visible}>
      <DialogTitle id="alert-dialog-title">{`Modifica orario: ${currentTime?.substring(0,5)} > ${moment(selectedTime).format('HH:mm')}`}</DialogTitle>
      <DialogContent>
        <Typography>L'orario selezionato deve essere approvato per poter essere modificato.</Typography>
        <Typography>Vuoi mandarlo in approvazione?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annulla</Button>
        <Button
          onClick={_onSendApprovement}
          autoFocus
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovementModal;
